module.exports = __webpack_public_path__ + "img/pin.43f6a08d.svg";